import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <div>
      <nav>
        <ul>
          <li>
            <Link to="/tag-generator">TagGenerator Custom Element</Link>
          </li>
          <li>
            <Link to="/video-manager">VideoManager Custom Element</Link>
          </li>
          <li>
            <Link to="/images-gallery">ImagesGallery Custom Element</Link>
          </li>
          <li>
            <Link to="/slug-generator">SlugGenerator Custom Element</Link>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default Home;
